import moment from 'moment';
import React, { Component } from 'react';
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import language from '../../../../assets/languages/language';
import { SecondsToHHMMSS } from '../../../../common/constant';
import Loader from '../../../../common/loader';
import CBTMockExamsInsructions from '../../../Common/CBTInstructions';
import ModalComponent from '../../../Common/Modal';
import Cfa1SubscriptionCheck from '../../../RestAPI/Cfa1Subscription';
import PartnerCfa1SubscriptionCheck from '../../../RestAPI/PartnerSubscription/Cfa1Subscription';
import FD from '../../../RestAPI/fetchData';
import AppRoutes from '../../../config/AppRoutes';
import App_data from '../../../config/App_data';
import AlertMessage from '../../../config/alertMessage';
import { nextAwareRoute } from '../../../../common/cfa1NextRoutes';
/* eslint-disable*/

class CBTMockExams extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alert_status: false,
      pdfAlert: false,
      MessageTitle: App_data.messageTitle_cfa,
      MessageContent: AlertMessage.messageContent_cfa_1,
      mockList: [],
      token: '',
      idname: '',
      ValidToken: false,
      subscriptionstatus: '',
      showFreePremium: true,
      selectedmenu: 'cfa',
      cfaUnlimitedPackage: '',
      cfaUnlimitedActiveExam: '',
      type: 'question',
      PDFContentMessage: language.LC().PDFContentMessage,
      isLoading: true,
      mockData: '',
      userStatsData: '',
      mockName: '',
      deletepopup: false,
      deleteId: '',
      questionsLength: 90,
    };
    this.toggleAlert = this.toggleAlert.bind(this);
  }

  toggleAlert() {
    this.setState({
      alert_status: !this.state.alert_status,
    });
  }

  //it is use to redirect page
  static contextTypes = {
    router: React.PropTypes.object,
  };

  //Function to redirect page to viewquestions page
  getQuestions = () => {
    this.setState({
      showInstructionModal: false,
      isLoading: true,
    });
    var user_data = { token: this.state.token, idname: this.state.idname };
    FD.callAPI(App_data.backend_api + '/user/getProfileInfo', user_data).then(resp => {
      if (resp.profileInfo.role === 'partner') {
        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
          this.setState({
            isLoading: false,
          });
          this.toggleAlert();
        } else {
          var subscription_details = resp.profileInfo.subscription_details
            ? JSON.parse(resp.profileInfo.subscription_details)
            : resp.profileInfo.subscription_details;
          // console.log(
          //   'resp.profileInfo.subscription_details',
          //   resp.profileInfo.subscription_details
          // );

          this.setState({
            subscription_details: subscription_details,
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });

          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;
                const mockPackageAccess = resp_exam.hasMockSubscription;
                isInArray_var = await PartnerCfa1SubscriptionCheck.checkCfa1Subscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                );
                if (isInArray_var || mockPackageAccess) {
                  this._runCode('paid');
                } else {
                  this.setState({
                    isLoading: false,
                  });
                  this.toggleAlert();
                }
              } else {
                // console.log('fail');
              }
            },
          );
        }
      } else {
        if (
          resp.profileInfo.exam_selected === '' &&
          resp.profileInfo.cfaUnlimitedPackage === '' &&
          resp.profileInfo.cfaUnlimitedActiveExam === ''
        ) {
          this.setState({
            isLoading: false,
          });
          this.toggleAlert();
        } else {
          // console.log('in paid');
          var subscription_details = resp.profileInfo.subscription_details
            ? JSON.parse(resp.profileInfo.subscription_details)
            : resp.profileInfo.subscription_details;

          this.setState({
            subscription_details: subscription_details,
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            resp_exam => {
              // console.log('resp of get exam by user', resp_exam);
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;
                isInArray_var = Cfa1SubscriptionCheck.checkCfa1Subscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                );
                // console.log('outside isInArray_var heeee', isInArray_var);
                if (isInArray_var) {
                  // console.log('inside isInArray_var ', isInArray_var);
                  this._runCode('paid');
                  this.setState({ subscriptionstatus: 'paid' });
                } else {
                  this.setState({
                    isLoading: false,
                  });
                  this.toggleAlert();
                }
              } else {
                // console.log('fail');
              }
            },
          );
        }
      }
    });
  };

  _runCode = subscriptionstatus => {
    this.setState({
      isLoading: false,
    });
    if (subscriptionstatus === 'paid') {
      this.context.router.push({
        pathname: nextAwareRoute(AppRoutes.CFA1_2024_CBT_INTRODUCTION)
          .replace(':id', this.props.params.id)
          .replace(':questiono', 1)
          .replace(':timer', this.props.params.timer),
      });
    }
  };

  //On Page Load,init this method
  async componentDidMount() {
    window.scrollTo(0, 0);
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({ idname: storage_session['idname'] });
    this.setState({ token: storage_session['token'] });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : '',
    };
    FD.callAPI(App_data.backend_api + '/cfaCBTMockExams/getAllUsersStats', data).then(resp => {
      if (resp.success) {
        FD.callAPI(App_data.backend_api + '/cfaCBTMockExams/getCFAMockQuestions', data).then(
          resp => {
            if (resp && resp.question) {
              this.setState({
                questionsLength: resp.question.length,
              });
            }
          },
        );
        this.setState({
          ValidToken: true,
          mockList: resp.data,
          isLoading: false,
          // userStatsData: resp.data,
        });
      } else {
        this.setState({ ValidToken: false, isLoading: false });
      }
      return resp;
    });

    FD.callAPI(App_data.backend_api + '/cfaCBTMockExams/getMockNamebyId', data).then(async res => {
      this.setState({
        mockName: res.mockdata && res.mockdata.mock_exam ? res.mockdata.mock_exam : '',
      });
    });
  }

  goPremium = () => {
    this.context.router.push({
      pathname: '/Subscribe/',
      state: {
        token: this.state.token,
        idname: this.state.idname,
        selectedMenu: this.state.selectedmenu,
      },
    });
  };

  startExam = () => {
    this.setState({
      showInstructionModal: true,
      // mockData: mock,
    });
  };
  backToMock = () => {
    this.context.router.push({
      pathname: nextAwareRoute(AppRoutes.CFA1_2024_CBT),
    });
  };
  deleteTest = id => {
    const { deletepopup } = this.state;
    if (!deletepopup) {
      this.setState({
        deleteId: id,
        deletepopup: true,
      });
    } else {
      this.setState({
        deleteId: '',
        deletepopup: false,
      });
    }
  };
  view = item => {
    // '/cfa1_2024/cbtquestionsfinish/:id/:questiono/:timer/:testid/:offset',
    const { id, timer } = this.props.params;
    this.context.router.push({
      // pathname: `/cfa1_2024/cbtquestionsfinish/${this.props.params.id}/1/${
      //   this.props.params.timer
      // }/${item.id}/0`,
      pathname: nextAwareRoute(AppRoutes.CFA1_2024_CBT_QUESTION_FINISH)
        .replace(':id', id)
        .replace(':questiono', 1)
        .replace(':timer', timer)
        .replace(':testid', item.id)
        .replace(':offset', 0),
    });
  };
  deleteToggleDone = () => {
    const { deleteId } = this.state;
    const deleteData = {
      token: this.state.token,
      idname: this.state.idname,
      id: deleteId,
    };
    FD.callAPI(App_data.backend_api + '/cfaCBTMockExams/deleteMock', deleteData).then(async res => {
      this.setState({
        deleteId: '',
        mockName: res.mockdata && res.mockdata.mock_exam ? res.mockdata.mock_exam : '',
        deletepopup: false,
      });

      var data = {
        token: this.state.token,
        idname: this.state.idname,
        mock_id: this.props.params.id ? parseInt(this.props.params.id) : '',
      };
      FD.callAPI(App_data.backend_api + '/cfaCBTMockExams/getAllUsersStats', data).then(resp => {
        if (resp.success) {
          this.setState({
            ValidToken: true,
            mockList: resp.data,
            isLoading: false,
            // userStatsData: resp.data,
          });
        } else {
          this.setState({ ValidToken: false, isLoading: false });
        }
        return resp;
      });
      FD.callAPI(App_data.backend_api + '/cfaCBTMockExams/getMockNamebyId', data).then(
        async res => {
          this.setState({
            mockName: res.mockdata && res.mockdata.mock_exam ? res.mockdata.mock_exam : '',
          });
        },
      );
    });
  };

  resumeTest = item => {
    // console.log('item', item);
    if (item.questions) {
      let questionsData = JSON.parse(item.lastAnswered);
      if (questionsData) {
        this.context.router.push({
          pathname: nextAwareRoute(AppRoutes.CFA1_2024_CBT_QUESTIONS)
            .replace(':id', this.props.params.id)
            .replace(':questiono', questionsData.questionId)
            .replace(':timer', item.user_time_value)
            .replace(':testid', item.id)
            .replace(':offset', questionsData.offset)
            .replace(':isNegative', 'true')
            .replace(':timerStart', 'true'),
        });
      }
    } else {
      var data = {
        token: this.state.token,
        idname: this.state.idname,
        mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      };
      FD.callAPI(App_data.backend_api + '/cfaCBTMockExams/getCFAMockQuestions', data).then(resp => {
        if (resp.success) {
          this.context.router.push({
            pathname: nextAwareRoute(AppRoutes.CFA1_2024_CBT_QUESTIONS)
              .replace(':id', this.props.params.id)
              .replace(
                ':questiono',
                resp.question && resp.question.length ? resp.question[0].id : 1,
              )
              .replace(':timer', item.user_time_value)
              .replace(':testid', item.id)
              .replace(':offset', 0)
              .replace(':isNegative', 'true')
              .replace(':timerStart', 'true'),
          });
        }
      });
    }
  };
  render() {
    const {
      mockList,
      isLoading,
      showInstructionModal,
      mockName,
      deletepopup,
      questionsLength,
    } = this.state;
    return (
      <div>
        <div className='animated fadeIn'>
          <div className='margin_bottom_20 ques-title-wrapper rem-left-pad'>
            <h1 className='section_head'>{mockName}</h1>
            <div className='two-btn-wrapper'>
              <button
                className='btn btn-primary pointer_class mid-btn'
                onClick={() => this.startExam()}
              >
                {language.LC().START}
              </button>
              <button
                className='btn btn-primary pointer_class mid-btn'
                onClick={() => this.backToMock()}
              >
                {language.LC().CHANGE_MOCK}
              </button>
            </div>
          </div>
          <Modal isOpen={deletepopup} toggle={this.deleteTest} className={'modal-primary'}>
            <ModalHeader>
              {language.LC().ALERT}
              <Button className='close' color='secondary' onClick={this.deleteTest}>
                ×
              </Button>
            </ModalHeader>
            <ModalBody>
              <div className='text-center'>
                <p className='margin_bottom_20'>
                  <strong>{language.LC().ARE_YOU_SURE_TO_DELETE_THIS}</strong>
                </p>
                <Button
                  className='btn btn-sm btn-primary'
                  color='primary'
                  onClick={this.deleteToggleDone}
                >
                  {language.LC().OK}
                </Button>
              </div>
            </ModalBody>
          </Modal>

          <div className='row' />
          <div className='row'>
            <div className='col-md-12'>
              <div className='card height_70vh'>
                <div className='table_responsive_wrapper'>
                  <div className='table-responsive'>
                    <table className='table_white_bg table table-remove-space'>
                      <thead>
                        <tr className='border_top_0'>
                          <th width='9%'>#</th>
                          <th>{language.LC().TOTAL_SCORE}</th>
                          <th>{language.LC().DATE}</th>
                          <th>{language.LC().TEST_COMPLETED_IN}</th>
                          <th>{language.LC().STATUS}</th>
                          <th className='text-center'>{language.LC().ACTION}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {isLoading ? (
                          <tr>
                            <Loader />
                          </tr>
                        ) : mockList.length ? (
                          mockList.map((item, index) => {
                            let time = 0;
                            if (item.isNegative === 'true') {
                              time = SecondsToHHMMSS(
                                parseInt(this.props.params.timer) - item.user_time_value,
                              );
                            } else {
                              time = SecondsToHHMMSS(
                                parseInt(this.props.params.timer) + item.user_time_value,
                              );
                            }
                            return (
                              <tr key={index}>
                                <td>{item.id}</td>
                                <td className='score-qnt'>
                                  {item.score && questionsLength
                                    ? `${Math.ceil((item.score / questionsLength) * 100)}%`
                                    : '0%'}
                                </td>
                                <td>{item.createdAt ? moment(item.createdAt).format('ll') : ''}</td>
                                <td className='clr-green'>{time}</td>
                                <td className='text-capitalize mock-status'>
                                  {item.status === 'pending' ? (
                                    <div className='mock-status not-attempted'>
                                      {language.LC().Incomplete}
                                    </div>
                                  ) : (
                                    <div className='mock-status'>{item.status}</div>
                                  )}
                                </td>
                                <td className='text-center'>
                                  {item.status === 'completed' ? (
                                    <span
                                      className='up tooltip-hover-questions'
                                      style={{ padding: '0 6px' }}
                                    >
                                      <div className='tootip_box'> {language.LC().VIEW} </div>
                                      <i
                                        onClick={() => this.view(item)}
                                        className='fa fa-eye mark-action-btn-dashboard'
                                        style={{ color: '#1f8ceb' }}
                                      >
                                        {' '}
                                      </i>
                                    </span>
                                  ) : null}
                                  {item.status === 'pending' ? (
                                    <span
                                      className='up tooltip-hover-questions'
                                      style={{ padding: '0 6px' }}
                                    >
                                      <div className='tootip_box'> {language.LC().RESUME}</div>
                                      <i
                                        className='fa fa-play-circle-o mark-action-btn-dashboard'
                                        aria-hidden='true'
                                        style={{ color: '#000' }}
                                        onClick={() => {
                                          this.resumeTest(item);
                                        }}
                                      />
                                    </span>
                                  ) : null}
                                  <span
                                    className='up tooltip-hover-questions'
                                    style={{ padding: '0 6px' }}
                                  >
                                    <div className='tootip_box'> {language.LC().DELETE} </div>
                                    <i
                                      onClick={() => {
                                        this.deleteTest(item.id);
                                      }}
                                      className='fa fa-trash mark-action-btn-dashboard'
                                      style={{ color: '#f51a00' }}
                                    >
                                      {' '}
                                    </i>
                                  </span>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan={'5'} className={'no-mocks'}>
                              <div className='no-qus-found no-mock-exam'>
                                <img
                                  width='82px'
                                  src={App_data.frontend_url + '/img/questions/icon_nomock.png'}
                                />
                                <h3 className='mt-1'>{language.LC().NO_MOCK_EXAM_FOUND}</h3>
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ModalComponent
          goPremium={this.goPremium.bind(this)}
          toggleAlert={this.toggleAlert.bind(this)}
          alert_status={this.state.alert_status}
          MessageContent={this.state.MessageContent}
        />
        <CBTMockExamsInsructions
          showInstructionModal={showInstructionModal}
          getQuestions={() => this.getQuestions()}
          handleClose={() => this.setState({ showInstructionModal: false })}
        />
      </div>
    );
  }
}

export default CBTMockExams;



// WEBPACK FOOTER //
// ./src/views/CFA1-2025/CFA1CBT/ViewAttemptedMocks/index.js